<template>
  <!--会议详情-->
  <div class="content meetingdetails">
    <div class="layui-fluid">
      <div class="layui-row">
        <div class="layui-col-md12">
          <!--面包屑-->
          <div
            class="layui-row"
            style="margin-bottom:20px"
          >
            <div class="layui-col-md8">
              <div style="margin-left: 20px;">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                  <el-breadcrumb-item>
                    <span
                      @click="mianbao"
                      style="color:black;cursor: pointer;font-weight: 600;"
                    >会议管理</span>
                  </el-breadcrumb-item>
                  <el-breadcrumb-item>会议详情</el-breadcrumb-item>
                </el-breadcrumb>
              </div>
            </div>
          </div>
          <div class="layui-row">
            <!--Tab-->
            <el-tabs
              v-model="activeName"
              @tab-click="handleClick"
            >
              <el-tab-pane
                label="会议信息"
                name="first"
              >
                <div class="layui-col-md12">
                  <div class="layui-tab layui-tab-card">
                    <div class="layui-tab-content">
                      <div class="layui-tab-item layui-show">
                        <div
                          class="layui-row"
                          style="border-bottom: 1px solid #ccc;padding-bottom: 20px;margin-bottom: 20px"
                        >
                          <div
                            class="layui-col-md2 layui-col-xs10"
                            style="margin-bottom:20px"
                          >
                            <div>
                              <img
                                :src="meet.conference.cover_url"
                                alt
                                width="100%;"
                              />
                            </div>
                          </div>
                          <div
                            class="layui-col-md9 layui-col-xs12 layui-col-md-offset"
                            style="margin-left:3%"
                          >
                            <div>
                              <h4 style="margin:0px 0px 15px 0px;font-weight:600">
                                {{meet.conference.name}} &nbsp;
                                <el-tag
                                  type="info"
                                  v-show="meet.conference.status_str=='暂停发布'"
                                >{{meet.conference.status_str}}</el-tag>
                                <el-tag
                                  type="info"
                                  v-show="meet.conference.status_str=='已发布'"
                                >{{meet.conference.status_str}}</el-tag>
                                <el-tag
                                  type="warning"
                                  v-show="meet.conference.status_str=='报名中'"
                                >{{meet.conference.status_str}}</el-tag>
                                <el-tag v-show="meet.conference.status_str=='会议中'">{{meet.conference.status_str}}</el-tag>
                                <el-tag
                                  type="info"
                                  v-show="meet.conference.status_str=='已结束'"
                                >{{meet.conference.status_str}}</el-tag>
                              </h4>
                              <p>
                                <span style="font-weight:600">会议地址：</span>
                                {{meet.conference.region}}{{meet.conference.specific_address}}
                              </p>
                              <p>
                                <span style="font-weight:600">报名时间：</span>
                                {{meet.conference.enroll_start_time | dateformats }}~{{meet.conference.enroll_end_time | dateformats}}
                              </p>
                              <p>
                                <span style="font-weight:600">会议时间：</span>
                                {{meet.conference.start_time | dateformat}}~{{meet.conference.end_time | dateformat}}
                              </p>
                              <p>
                                <span style="font-weight:600">会议编码：</span>
                                {{meet.conference.code}}
                              </p>
                              <p>
                                <span style="font-weight:600">主办方：</span>
                                {{meet.conference.organizers}}
                              </p>
                              <p>
                                <span style="font-weight:600">会议简介：</span>
                                <span id="meet_jj"></span>
                              </p>
                              <p>
                                <span style="font-weight:600">会议介绍：</span>
                                <span id="meet_js"></span>
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="layui-card">
                          <div class="layui-card-header">会务费/门票管理</div>
                          <div class="layui-card-body">
                            <el-table
                              :data="meet.ticket"
                              stripe
                              style="width: 100%"
                            >
                              <el-table-column
                                prop="name"
                                label="门票名称"
                              ></el-table-column>
                              <el-table-column
                                prop="price"
                                label="价格"
                              ></el-table-column>
                              <el-table-column
                                prop="number"
                                label="门票总量"
                              ></el-table-column>
                              <el-table-column
                                prop="a_num"
                                label="剩余量"
                              >
                                <template slot-scope="scope">{{scope.row.number-scope.row.sold_num}}</template>
                              </el-table-column>
                              <!-- <el-table-column prop="purchased_num" label="已购数量"></el-table-column> -->
                            </el-table>
                          </div>
                        </div>
                        <div class="layui-card">
                          <div class="layui-card-header">住宿管理</div>
                          <div class="layui-card-body">
                            <el-table
                              :data="meet.hotel"
                              stripe
                              style="width: 100%"
                            >
                              <el-table-column
                                prop="hotel_info.h_name"
                                label="酒店名称"
                              ></el-table-column>
                              <el-table-column
                                prop="hotel_info.hotel_type"
                                label="房型名称"
                              ></el-table-column>
                              <el-table-column
                                prop="hotel_info.price"
                                label="预定时间"
                              >
                                <template slot-scope="scope">
                                  <span>{{scope.row.hotel_info.start_time | dateformat}}</span>~
                                  <span>{{scope.row.hotel_info.end_time | dateformat}}</span>
                                </template>
                              </el-table-column>
                              <el-table-column
                                prop="hotel_info.price"
                                label="住宿价格"
                              ></el-table-column>
                              <el-table-column
                                prop="hotel_info.quantity"
                                label="房间总量"
                              ></el-table-column>
                              <el-table-column label="剩余量">
                                <template slot-scope="scope">{{scope.row.hotel_info.quantity-scope.row.sold_quantity}}</template>
                              </el-table-column>
                              <!-- <el-table-column prop="name" label="已购人数"></el-table-column> -->
                            </el-table>
                          </div>
                        </div>
                        <div class="layui-card">
                          <div class="layui-card-header">就餐管理</div>
                          <div class="layui-card-body">
                            <el-table
                              :data="meet.repast"
                              stripe
                              style="width: 100%"
                            >
                              <el-table-column
                                prop="repast_info.address"
                                label="餐饮地点"
                              ></el-table-column>
                              <el-table-column
                                prop="repast_info.is_muslim"
                                label="是否清真"
                                :formatter="qingz"
                              ></el-table-column>
                              <el-table-column
                                prop="repast_info.price"
                                label="就餐价格"
                              ></el-table-column>
                              <el-table-column label="就餐日期">
                                <template slot-scope="scope">
                                  <span>{{scope.row.repast_info.start_time | dateformat}}</span>~
                                  <span>{{scope.row.repast_info.end_time | dateformat}}</span>
                                </template>
                              </el-table-column>
                              <el-table-column
                                prop="quantity"
                                label="预定总数"
                              ></el-table-column>
                              <el-table-column label="剩余量">
                                <template slot-scope="scope">{{scope.row.quantity-scope.row.sold_quantity}}</template>
                              </el-table-column>
                            </el-table>
                          </div>
                        </div>
                        <div class="layui-card">
                          <div class="layui-card-header">报名字段</div>
                          <div class="layui-card-body">
                            <el-table
                              :data="meet.enroll_field"
                              stripe
                              style="width: 100%"
                            >
                              <!-- <el-table-column prop="date" label="排序" width="180"></el-table-column> -->
                              <el-table-column
                                prop="field_name"
                                label="报名字段"
                              ></el-table-column>
                              <el-table-column
                                prop="form_type"
                                label="字段类型"
                                :formatter="type_form"
                              ></el-table-column>
                              <el-table-column
                                prop="is_required"
                                label="是否必填"
                                :formatter="yes_no"
                              ></el-table-column>
                            </el-table>
                          </div>
                        </div>
                        <div class="layui-card">
                          <div class="layui-card-header">首页背景图</div>
                          <div class="layui-card-body">
                            <div class="layui-row">
                              <div class="layui-col-md1 layui-col-xs6">
                                <div>
                                  <img
                                    :src="meet.share.background"
                                    alt
                                    width="50"
                                  />
                                </div>
                              </div>
                              <div class="layui-col-md11 layui-col-xs6">
                                <p class="layui-elip">上传合适的封面，利于您活动的宣传分享。</p>
                                <p class="layui-elip">推荐尺寸:移动端尺寸，中间内容尺寸750*1624，整图尺寸1644*1920。</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- <div class="layui-card">
                      <div class="layui-card-header">微信分享图标</div>
                      <div class="layui-card-body">
                        <div class="layui-row">
                          <div class="layui-col-md1 layui-col-xs6">
                            <div>
                              <img :src="meet.share.share_img" alt width="50" />
                            </div>
                          </div>
                          <div class="layui-col-md11 layui-col-xs6">
                            <p class="layui-elip">建议尺寸：高度保持66px，宽度不限</p>
                          </div>
                        </div>
                      </div>
                        </div>-->
                        <div class="layui-card">
                          <div class="layui-card-header">平行会议</div>
                          <div class="layui-card-body">
                            <el-table
                              :data="meet.parallel_conference"
                              stripe
                              style="width: 100%"
                            >
                              <el-table-column
                                prop="name"
                                label="会议名称"
                              ></el-table-column>
                              <el-table-column
                                prop="field_name"
                                label="会议地址"
                              >
                                <template slot-scope="scope">{{scope.row.region}}.{{scope.row.specific_address}}</template>
                              </el-table-column>
                              <el-table-column
                                prop="form_type"
                                label="会议时间"
                                :formatter="type_form"
                              >
                                <template slot-scope="scope">
                                  <span>{{scope.row.start_time | dateformat}}</span>~
                                  <span>{{scope.row.end_time | dateformat}}</span>
                                </template>
                              </el-table-column>
                              <el-table-column
                                prop="organizers"
                                label="主办方"
                              ></el-table-column>
                            </el-table>
                          </div>
                        </div>
                        <div class="layui-card">
                          <div class="layui-card-header">栏目管理</div>
                          <div class="layui-card-body">
                            <el-table
                              :data="meet.column"
                              stripe
                              style="width: 100%"
                            >
                              <el-table-column
                                prop="id"
                                label="排序"
                              ></el-table-column>
                              <el-table-column
                                prop="title"
                                label="栏目名称"
                              ></el-table-column>
                              <el-table-column
                                prop="type"
                                label="栏目类型"
                                :formatter="lan_type"
                              ></el-table-column>
                            </el-table>
                          </div>
                        </div>
                        <div class="layui-card">
                          <div class="layui-card-header">会议模板</div>
                          <div class="layui-card-body">
                            <div>
                              <img
                                :src="meet.template_img"
                                alt
                                width="150"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane
                label="报名信息"
                name="second"
              >
                <!-- <el-button type="primary" @click="baoming">查看会议报名信息</el-button> -->
              </el-tab-pane>
              <el-tab-pane
                label="订单数据"
                name="third"
              >
                <!-- <el-button type="primary" @click="dingdan">查看会议订单数据</el-button> -->
              </el-tab-pane>
              <el-tab-pane
                label="关注用户"
                name="fourth"
              >
                <el-table
                  :data="tableData"
                  style="width: 100%"
                >
                  <el-table-column
                    prop="member_info.name"
                    label="姓名"
                  ></el-table-column>
                  <el-table-column
                    prop="member_info.nickname"
                    label="昵称"
                  ></el-table-column>
                  <el-table-column
                    prop="member_info.mobile"
                    label="手机号"
                  ></el-table-column>
                  <el-table-column label="关注时间">
                    <template slot-scope="scope">
                      <div>{{scope.row.create_time | dateformat}}</div>
                    </template>
                  </el-table-column>
                </el-table>
                <!-- 分页 -->
                <div style="width:100%;text-align: center">
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-size="pageSize"
                    layout="total, prev, pager, next"
                    background
                    :total="total"
                    style="margin-top:20px;"
                  ></el-pagination>
                </div>
              </el-tab-pane>
              <el-tab-pane
                label="酒店信息"
                name="five"
              >
                <el-row style="margin-bottom: 20px;">
                  <el-col :span="5">
                    <el-date-picker
                      v-model="timehotel"
                      type="date"
                      value-format="timestamp"
                      placeholder="选择日期"
                    >
                    </el-date-picker>
                  </el-col>
                  <el-col :span="3">
                    <el-button
                      type="primary"
                      @click="hotelsearch"
                    >搜索</el-button>
                  </el-col>
                </el-row>
                <el-table
                  :data="htoeldata"
                  :cell-style="rowClass"
                  :header-cell-style="headClass"
                  :span-method="arraySpanMethod"
                  stripe
                  border
                  style="width: 100%;"
                >
                  <el-table-column
                    prop="name"
                    label="酒店名称"
                    width="180"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="finished"
                    label="订单完成"
                    width="180"
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.finished==0"></span>
                      <span v-else>{{scope.row.finished}}</span>
                    </template>

                  </el-table-column>
                  <el-table-column
                    label="待支付(线下)"
                    prop="waitting"
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.waitting==0"></span>
                      <span v-else>{{scope.row.waitting}}</span>
                    </template>

                  </el-table-column>
                  <el-table-column
                    label="申请退款"
                    prop="application"
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.application==0"></span>
                      <span v-else>{{scope.row.application}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="申请退款驳回"
                    prop="reject"
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.reject==0"></span>
                      <span v-else>{{scope.row.reject}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="合计"
                    prop="total_count"
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.total_count==0"></span>
                      <span v-else>{{scope.row.total_count}}</span>
                    </template>
                  </el-table-column>
                </el-table>
                <el-alert
                  v-show="htoeldatas!=''"
                  :title="timeval+'及以前入住的'"
                  type="info"
                  :closable="false"
                  style="color: #000000;margin-top: 20px;"
                >
                </el-alert>
                <el-table
                  v-show="htoeldatas!=''"
                  :data="htoeldatas"
                  :cell-style="rowClass"
                  :header-cell-style="headClass"
                  :span-method="arraySpanMethod"
                  stripe
                  border
                  style="width: 100%;"
                >
                  <el-table-column
                    prop="name"
                    label="酒店名称"
                    width="180"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="finished"
                    label="订单完成"
                    width="180"
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.finished==0"></span>
                      <span v-else>{{scope.row.finished}}</span>
                    </template>

                  </el-table-column>
                  <el-table-column
                    label="待支付(线下)"
                    prop="waitting"
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.waitting==0"></span>
                      <span v-else>{{scope.row.waitting}}</span>
                    </template>

                  </el-table-column>
                  <el-table-column
                    label="申请退款"
                    prop="application"
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.application==0"></span>
                      <span v-else>{{scope.row.application}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="申请退款驳回"
                    prop="reject"
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.reject==0"></span>
                      <span v-else>{{scope.row.reject}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="合计"
                    prop="total_count"
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.total_count==0"></span>
                      <span v-else>{{scope.row.total_count}}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import moment from "moment";
layui.use("element", function () {
  var element = layui.element;
});

export default {
  name: "MeetingDetails",
  data () {
    return {
      /* 时间入住 */
      timehotel: "",
      timeval: "",
      tableData: [],
      htoeldata: [],
      htoeldatas: [],
      activeName: "first",
      /* 会务费/门票管理 */
      meet: {
        conference: {},
        ticket: [],
        enroll_field: [],
        share: {
          background: "3xxxx",
          share_img: "2xxxx",
        },
        parallel_conference: [],
        column: [],
        template_img: "1xxxxxx",
      },
      /* 报名信息 */
      information: [],
      /* 订单数据 */
      order: [],
      ed_id: "",
      cur: "",
      total: 0,
      pageSize: 8,
      currentPage: 1,
      listLoading: false,
    };
  },
  created () {
    this.ed_id = this.$route.query.editId;
    this.cur = this.$route.query.cur;

  },
  methods: {
    /* 搜索酒店 */
    hotelsearch () {
      var _this = this
      _this.timeval = moment(_this.timehotel).format("YYYY.MM.DD");
      console.log(_this.timehotel);
      _this.gethotels()
    },
    headClass () {
      return 'text-align: center;'
    },
    rowClass () { //表格数据居中显示
      return "text-align:center"
    },
    arraySpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === this.htoeldata.length - 1)
      {
        if (columnIndex === 1)
        {
          return [2, 6];
        }
      }
    },
    /* 获取酒店信息 */
    gethotels () {
      var _this = this
      var url = "/ac1/conference/hotel/accomStatistics"
      var hotelarr = []
      var hotelarrs = []
      var params = {
        id: this.ed_id,
        time: this.timehotel / 1000
      }
      _this.$get(url, params).then(res => {
        console.log(res);
        if (res.code == 1)
        {
          var arr = res.posts[0]
          var obj = {}
          for (let i = 0; i < arr.hotel_data.length; i++)
          {
            var state = arr.hotel_data[i]
            obj = {
              name: state.name,
              total_count: state.total_count,
              finished: state.count[0].count,
              application: state.count[1].count,
              reject: state.count[2].count,
              waitting: state.count[3].count,
            }
            hotelarr.push(obj)
          }
          var objs = {
            name: "订单",
            total_count: arr.order_data.total_count,
            finished: arr.order_data.count_data[0].count,
            application: arr.order_data.count_data[1].count,
            reject: arr.order_data.count_data[2].count,
            waitting: arr.order_data.count_data[3].count,

          }
          hotelarr.push(objs)
          var objss = {
            name: "住宿人数",
            total_count: arr.user_data.total_count,
            finished: arr.user_data.count_data[0].count,
            application: arr.user_data.count_data[1].count,
            reject: arr.user_data.count_data[2].count,
            waitting: arr.user_data.count_data[3].count,

          }
          hotelarr.push(objss)
          var objsss = {
            name: "房间总计",
            total_count: arr.total_count,
            finished: arr.total_count,
            application: arr.total_count,
            reject: arr.total_count,
            waitting: arr.total_count,

          }
          hotelarr.push(objsss)

          if (res.posts[1])
          {
            var arrs = res.posts[1]
            var objk = {}
            for (let a = 0; a < arrs.hotel_data.length; a++)
            {
              var states = arrs.hotel_data[a]
              objk = {
                name: states.name,
                total_count: states.total_count,
                finished: states.count[0].count,
                application: states.count[1].count,
                reject: states.count[2].count,
                waitting: states.count[3].count,
              }
              hotelarrs.push(objk)
            }
            var objsk = {
              name: "订单",
              total_count: arrs.order_data.total_count,
              finished: arrs.order_data.count_data[0].count,
              application: arrs.order_data.count_data[1].count,
              reject: arrs.order_data.count_data[2].count,
              waitting: arrs.order_data.count_data[3].count,

            }
            hotelarrs.push(objsk)
            var objssk = {
              name: "住宿人数",
              total_count: arrs.user_data.total_count,
              finished: arrs.user_data.count_data[0].count,
              application: arrs.user_data.count_data[1].count,
              reject: arrs.user_data.count_data[2].count,
              waitting: arrs.user_data.count_data[3].count,

            }
            hotelarrs.push(objssk)
            var objsssk = {
              name: "房间总计",
              total_count: arrs.total_count,
              finished: arrs.total_count,
              application: arrs.total_count,
              reject: arrs.total_count,
              waitting: arrs.total_count,

            }
            hotelarrs.push(objsssk)
          }
        }
        _this.htoeldata = hotelarr
        _this.htoeldatas = hotelarrs
      })

    },
    handleClick (tab, event) {
      console.log(tab.label);
      var _this = this;
      if (tab.label == "报名信息")
      {
        _this.baoming();
      } else if (tab.label == "订单数据")
      {
        _this.dingdan();
      }
    },
    /*面包屑 */
    mianbao () {
      if (this.$route.query.tab_name == "second")
      {
        this.cur = 1
      }
      this.$router.push({
        path: "/admin/MyMeeting",
        query: {
          cur: this.cur,
          tab_name: this.$route.query.tab_name
        },
      });
    },
    baoming () {
      this.$router.push({
        path: "/admin/TheRegistrationManagement",
        query: {
          id: this.ed_id,
          cur: this.cur,
        },
      });
    },
    dingdan () {
      this.$router.push({
        path: "/admin/TheOrderManagement",
        query: {
          id: this.ed_id,
          cur: this.cur,
        },
      });
    },
    /* 关注用户 */
    getlist (currentPage, pageSize) {
      var _this = this;
      let url = _this.APIurl.API.api.guanzuman;
      var params = {
        id: _this.ed_id,
        page: currentPage,
        pagesize: pageSize,
      };
      _this.$get(url, params).then((res) => {
        console.log(res);
        _this.tableData = res.posts.data;
        _this.total = res.posts.count;
      });
    },
    /*点击上一页,下一页 */
    handleSizeChange: function (size) {
      this.pageSize = size;
      console.log(this.pageSize); //每页下拉显示数据
      this.showTable(this.currentPage, this.pageSize); /* 请求数据 */
    },
    /* 点击分页下标 */
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
      console.log(this.currentPage); //点击第几页
      this.showTable(this.currentPage, this.pageSize); /* 请求数据 */
    },
    /* 判断栏目类型 */
    lan_type (row) {
      if (row.type == "1")
      {
        return "内容单页";
      } else if (row.type == "2")
      {
        return "内容列表";
      } else if (row.type == "3")
      {
        return "跳转链接";
      } else if (row.type == "4")
      {
        return "附件下载";
      } else if (row.type == "5")
      {
        return "关联嘉宾";
      } else if (row.type == "6")
      {
        return "会议详情";
      } else if (row.type == "7")
      {
        return "我的报名";
      } else if (row.type == "8")
      {
        return "发票开票";
      } else if (row.type == "9")
      {
        return "会后-媒体报道";
      } else if (row.type == "10")
      {
        return "会后-会议资料";
      } else if (row.type == "11")
      {
        return "会后-会议回顾";
      }
    },
    /* 判断就餐是否清真 */
    qingz (row) {
      if (row.repast_info.is_muslim == "1")
      {
        return "是";
      } else if (row.repast_info.is_muslim == "0")
      {
        return "否";
      }
    },
    /* 判断报名字段表单类型 */
    type_form (row) {
      if (row.form_type == "1")
      {
        return "内容单页";
      } else if (row.form_type == "2")
      {
        return "内容列表";
      } else if (row.form_type == "3")
      {
        return "单选";
      } else if (row.form_type == "4")
      {
        return "多选";
      } else if (row.form_type == "5")
      {
        return "下拉框";
      } else if (row.form_type == "6")
      {
        return "时间";
      } else
      {
        return "无类型";
      }
    },
    /* 判断报名字段是否必填*/
    yes_no (row) {
      if (row.is_required == "1")
      {
        return "是";
      } else if (row.is_required == "0")
      {
        return "否";
      }
    },
    /* 会议信息内容 */
    mettting () {
      var _this = this;
      let url = _this.APIurl.API.api.meetinformation;
      var params = {
        id: _this.ed_id,
      };
      _this.$get(url, params).then((res) => {
        console.log(res);
        _this.meet = res.posts;
        var a = _this.meet.conference.desc;
        $("#meet_jj").html(`
      <span>${a}</span>    
     `);
        var b = _this.meet.conference.detail;
        $("#meet_js").html(`
      <span>${b}</span>    
    `);
      });
    },
  },
  mounted () {
    this.mettting();
    this.gethotels()
    this.getlist(this.currentPage, this.pageSize);
  },
  updated () { },
};
</script>

<style scoped>
.el-table td,
.el-table th {
  text-align: center;
}
@media screen and (min-width: 320px) and (max-width: 750px) {
  .meetingdetails .button {
    margin-top: 10px;
  }
}
</style>
<style>
</style>
